import { getIt } from "ap-components";
import axios, { AxiosInstance } from "axios";
import { singleton } from "tsyringe";
import SharedPrefs from "./SharedPrefs";
import { launchPage } from "../Common/Utils";
import { plainToInstance } from "class-transformer";
import SendOTPResponseClass from "../Models/SendOTPResponseModel";

@singleton()
export default class EmpanelmentService {

    instance: AxiosInstance = axios.create({
        baseURL: import.meta.env.REACT_APP_EMPANELMENTURL
    });
    constructor() {
        this.instance.interceptors.request.use((config) => {
            config.headers.Authorization = "Bearer " + getIt(SharedPrefs).getItem('poToken');
            config.headers["dashboard-version"] = "2102110000";
            return config;
        }, (error => {
            return Promise.reject(error);
        }));

        this.instance.interceptors.response.use((v) => v, (error) => {
            if (error?.response?.status === 401 || error?.response?.statusText === "Unauthorized" || error?.response?.data?.metaData?.invalidSignup) {
                getIt(SharedPrefs).removeToken();
                getIt(SharedPrefs).removeItem('poToken');
                launchPage('/signup/verification');
            }
            if (error?.response?.data?.userMsg)
                error.message = error.response.data.userMsg;
            return Promise.reject(error);
        })
    }

    async getEmpanelmentData() {
        var response = await this.instance.request({
            method: 'GET',
            url: '/signupv3/getEmpanelmentData',
        });

        return response.data;
    }

    async getLogData({ logId }: { logId: string }) {
        var response = await this.instance.request({
            method: 'GET',
            url: `/signupv3/getLogData?logId=${logId}`,
        });

        return response.data;
    }

    async sendOTPv2(request: { arn: string, email: string, phone: string, pan: string, dob: string }) {
        var response = await this.instance.request({
            method: 'POST',
            url: '/signupv3/sendOTP',
            data: request
        });
        return plainToInstance(SendOTPResponseClass, response.data);
    }

    async verifyOTPv2(request: { arn: string, emailotp?: string, phoneotp?: string, utm_campaign?: string, utm_medium?: string, utm_source?: string, referrer?: string, logId: string, lat?: number, long?: number, pan: string, dob: string }): Promise<any> {
        var response = await this.instance.request({
            method: 'POST',
            url: '/signupv3/verifyOTP',
            data: request
        });
        return response.data;
    }

    async saveBankDetailsv2(request: { ifsc: string, accountNumber: string, bankImageBase64?: string }): Promise<any> {
        var response = await this.instance.request({
            method: 'POST',
            url: '/signupv3/saveBankDetails',
            data: request
        });
        return response.data;
    }

    async savePersonalDetails(request: {
        arn: string,
        euin: string,
        euinData?: string,
        nomineeName?: string,
        nomineeRelationship?: string,
    }): Promise<any> {
        var response = await this.instance.request({
            method: 'POST',
            url: '/signupv3/savePersonalDetails',
            data: request
        });
        return response.data;
    }

    async checkIFSC(ifsc: string): Promise<any> {
        var response = await this.instance.request({
            method: 'GET',
            url: '/admin/checkIFSC',
            params: { ifsc }
        })
        return response.data;
    }

    async resendOtp(request: { logId: string, type: 'email' | 'phone' }) {
        var response = await this.instance.request({
            method: 'POST',
            url: '/signupv3/sendOTP/resend',
            data: request
        });
        return plainToInstance(SendOTPResponseClass, response.data);
    }

}